module.exports = __webpack_public_path__ + "assets/ae2b8564774464747c5a96b1fb2efc99.jpg";